<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_xi"></a>FREE <span class="smallcaps">AND</span> FRENCH <span class="smallcaps">IN THE</span> CARIBBEAN</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?6da195d3